import { Popover, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import PropTypes from 'prop-types';
import React from 'react';

export default function Tooltip({
  children = null,
  content = '',
  position = 'left',
}) {
  const [opened, { close, open }] = useDisclosure(false);

  return (
    <Popover opened={opened} position={position} shadow="lg" withArrow>
      <Popover.Target>
        <div
          onMouseEnter={open}
          onMouseLeave={close}
          style={{ width: 'fit-content' }}
        >
          {children}
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <Text size="sm">{content}</Text>
      </Popover.Dropdown>
    </Popover>
  );
}

Tooltip.propTypes = {
  children: PropTypes.node,
  content: PropTypes.string,
  position: PropTypes.string,
};
